module.exports = __webpack_public_path__ + "img/blank-vehicle-hire.8ca111ac.png";